import * as yup from 'yup'

const baseSchema = {
  // ABI Filer - mandatory fields
  filerPortCode: yup.string().required('Port Code is required.'),
  filerCode: yup.string().required('Filer Code is required.'),
  // ABI Entry Number - mandatory fields
  entryNumberSet: yup.string().required('Set is required.'),
  entryNumberRangeStart: yup.number()
    .typeError('Range Start must be a number.')
    .required('Range Start is required.'),
  entryNumberRangeEnd: yup.number()
    .typeError('Range End must be a number.')
    .required('Range End is required.'),
};

export const customTest = (base = {}) => yup.object({ ...baseSchema, ...base })
.test(
  'entry-number-range-valid', // test name
  'Range Start cannot be greater than Range End.', // error message
  function (value) {
    const { entryNumberRangeStart, entryNumberRangeEnd } = value;
    if (entryNumberRangeStart && entryNumberRangeEnd
      && entryNumberRangeStart > entryNumberRangeEnd) {
      return new yup.ValidationError([
        new yup.ValidationError(
          'Range Start cannot be greater than Range End.',
          entryNumberRangeStart,
          'entryNumberRangeStart'
        ),
        new yup.ValidationError(
          'Range End cannot be lesser than Range Start.',
          entryNumberRangeEnd,
          'entryNumberRangeEnd'
        )
      ])
    }
    return true;
  }
)